import { ApiError } from '@/api/rest';

import { cx } from './cx';

/**
 * Notice — строка о том, почему на месте раздела ничего нет.
 *
 * Отсутствие и отказ разведены намеренно. `501` значит «ручка объявлена
 * контрактом и не написана»: повторять её нельзя, функциональность прячется
 * в UI. Красным про это писать нельзя — человек прочитает «сломалось» и пойдёт
 * чинить несломанное.
 */
export interface Notice {
  text: string;
  kind: 'absent' | 'error';
}

export function NoticeLine({ notice }: { notice: Notice }) {
  return (
    <p className={cx('mt-2 text-base', notice.kind === 'error' ? 'text-acc' : 'text-mute')}>
      {notice.text}
    </p>
  );
}

/**
 * Отказ сервера человеческим языком. Решения принимаются по `code` и статусу,
 * текст существует только для экрана (`../clown-back/docs/auth-flow.md`).
 *
 * 404 здесь нет: «не найдено» звучит по-разному для комнаты, пака и партии,
 * и добавляет его тот, кто знает, что именно искал.
 */
export function describeApiError(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.isNotImplemented) return 'Пока не поддерживается сервером';
    if (err.isTransient) return 'Сервер недоступен, попробуйте ещё раз';
    if (err.isUnauthorized) return 'Вход не подтвердился';
    if (err.isOutdated) return 'Нужно обновить приложение';
  }
  return 'Не получилось. Попробуйте ещё раз';
}
